module.exports = __webpack_public_path__ + "img/star4.8d5c8142.png";